// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1l6Lp","heading":"_3c8lL","subHeading":"_2m9dM"};